type ClassValue = string | number | boolean | undefined | null | ClassValue[] | { [key: string]: boolean | undefined | null };

/**
 * 合并 className
 * 提供类型安全的 className 合并功能
 *
 * @example
 * ```ts
 * cn('btn', 'btn-primary'); // 'btn btn-primary'
 * cn('btn', { 'btn-active': true }); // 'btn btn-active'
 * cn('btn', { 'btn-disabled': false }); // 'btn'
 * cn('btn', ['btn-primary', 'btn-lg']); // 'btn btn-primary btn-lg'
 * ```
 */
export function cn(...inputs: ClassValue[]): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) {
 continue;
}

    if (typeof input === 'string' || typeof input === 'number') {
      classes.push(String(input));
    } else if (Array.isArray(input)) {
      const inner = cn(...input);
      if (inner) {
 classes.push(inner);
}
    } else if (typeof input === 'object') {
      for (const key in input) {
        if (input[key]) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(' ');
}
